// extracted by mini-css-extract-plugin
module.exports = {"panelWrap":"Panel_panelWrap__2Iadv","animate":"Panel_animate__2F2HE","load":"Panel_load__3dFVW","cornerComponentWrap":"Panel_cornerComponentWrap__OBmTa"};